export enum Pages {
  home = '/',
  adminPage = '/admin',
  adminUserGroups = '/admin/userGroups',

  billingDetailsList = '/billingDetails',
  billingDetails = '/billingDetails/:billingDetailsId',
  paymentClaimsList = '/paymentClaims',
  paymentClaims = '/paymentClaims/:paymentClaimId',

  passagesList = '/passages',
  passageDetails = '/passages/:passageId',

  receiptList = '/receipts',
  receiptDetails = '/receipts/:receiptId',

  iTicketList = '/iTickets',
  iTicketDetails = '/iTickets/:iTicketNumber',

  transactionList = '/transactions',
  transactionDetails = '/transactions/:transactionId',

  exceptionListList = '/exceptionLists',
  exceptionListDetails = '/exceptionLists/:exceptionListId',

  contractIssuerLists = '/contractIssuerLists',
  contractIssuerListDetails = '/contractIssuerLists/:contractIssuerListId',

  actionLists = '/actionLists',
  actionListDetails = '/actionLists/:actionListId',

  auditLog = '/auditLog',

  efcContextData = '/efcContextData',
  efcContextDataInbound = '/efcContextData/inbound',
  efcContextDataOutbound = '/efcContextData/outbound',

  oresundsbronDataDetails = '/oresundsbronData',
  oresundsbronDataEdit = '/oresundsbronData/edit',

  tollServiceProviderList = '/tollServiceProvider',
  tollServiceProviderNew = '/tollServiceProvider/new',
  tollServiceProviderDetails = '/tollServiceProvider/:tollServiceProviderId',
  tollServiceProviderEdit = '/tollServiceProvider/:tollServiceProviderId/edit',

  localAgreements = '/localAgreements',
  localAgreementDetails = '/localAgreements/:localAgreementId',
}
